// Vendors
import React, { useCallback } from 'react'
import { useForm } from 'react-hook-form'

// Components
import { FieldTextArea } from 'components/FieldTextArea'

// Styles
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ButtonGroup,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
  Stack,
  Text,
} from '@chakra-ui/react'
import { useError } from 'hooks/useError'
import { apiDelete } from 'services/delete'

type ModalCancelIssuedInvoiceProps = {
  isOpen: boolean
  purchaseId: string
  reload: () => void
  onCancel: () => void
}

type FormCancelIssuedInvoice = {
  comments: string
}

export const ModalCancelIssuedInvoice = (
  props: ModalCancelIssuedInvoiceProps
) => {
  const { isOpen, reload, onCancel, purchaseId } = props

  const {
    reset,
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<FormCancelIssuedInvoice>()

  const { handleError } = useError()

  const onClose = useCallback(() => {
    reset()
    onCancel()
  }, [onCancel, reset])

  const onSubmit = useCallback(
    async (data: FormCancelIssuedInvoice) => {
      try {
        await apiDelete(`/app/purchase/${purchaseId}/invoice_note`, {
          comments: data.comments,
        })

        reload()
        onClose()
      } catch (error) {
        handleError(error)
      }
    },
    [handleError, onClose, purchaseId, reload]
  )

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />

      <ModalContent as="form" onSubmit={handleSubmit(onSubmit)}>
        <ModalHeader>Cancelar nota fiscal emitida</ModalHeader>

        <ModalCloseButton />

        <ModalBody>
          <Text color="gray.500" mb="4">
            Para cancelar e remover a nota, por favor preencha os campos abaixo:
          </Text>

          <Stack>
            <FieldTextArea
              label="Justificativa"
              error={errors.comments}
              placeholder="Digite uma justificativa"
              {...register('comments', {
                required: 'Por favor, preencha o campo de justificativa',
              })}
            />
          </Stack>

          <Text fontSize="sm" color="orange.500" mt="4" fontStyle="italic">
            Após remover uma nota emitida você poderá incluir outra nota fiscal.
          </Text>
        </ModalBody>

        <ModalFooter>
          <ButtonGroup>
            <Button onClick={onClose}>Cancelar</Button>
            <Button type="submit" colorScheme="blue" isLoading={isSubmitting}>
              Confirmar
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
